// extracted by mini-css-extract-plugin
module.exports = {"b1sstqy5":"b1sstqy5","wcnkszl":"wcnkszl"};